import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from "react-router-dom";

import { Toast } from 'primereact/toast';
import { ProgressBar } from 'primereact/progressbar';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { Splitter, SplitterPanel } from 'primereact/splitter';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tooltip } from 'primereact/tooltip';

import { EntityList } from '../../../components/EntityList';
import { ViewService } from '../../../service/ViewService';
import { LanguageService } from '../../../service/LanguageService';
import * as moment from 'moment';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { AutoComplete } from 'primereact/autocomplete';
import { ContextMenu } from 'primereact/contextmenu';

import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

import { FinancialRecordsUploader } from './FinancialRecordsUploader';
import { FinancialPresetManager } from './FinancialPresetManager';
import { RecordSplitter } from './RecordSplitter';
import { Message } from 'primereact/message';

function ConciliatePeriod(props) {

    const history = useHistory();
    const toast = useRef(null);
    const frcm = useRef(null);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [pendingUpdates, setPendingUpdates] = useState(false);
    const [classifying, setClassifying] = useState(false);

    const [customer, setCustomer] = useState({});
    const [account, setAccount] = useState({});
    const [conciliationPeriod, setConciliationPeriod] = useState({id: props.match.params.id});
    const [financialRecords, setFinancialRecords] = useState([]);
    const [conciliationRecords, setConciliationRecords] = useState([]);
    const [customerRecords, setCustomerRecords] = useState([]);
    const [customerCategories, setCustomerCategories] = useState([]);


    const [selectedConciliationRecords, setSelectedConciliationRecords] = useState([]);
    const [selectedCompanyRecords, setSelectedCompanyRecords] = useState([]);

    const [conciliationRecordsSort, setConciliationRecordsSort] = useState({ sortField: "date", sortOrder: 1});


    const [selectionAccountingAccount, setSelectionAccountingAccount] = useState(null);
    const [accountigAccounts, setAccountigAccounts] = useState([]);
    const [selectionAccountingCostCenter, setSelectionAccountingCostCenter] = useState(null);
    const [accountigCostCenters, setAccountigCostCenters] = useState(null);
    const [selectionFinancialCategory, setSelectionFinancialCategory] = useState(null);
    const [financialCategories, setFinancialCategories] = useState(null);
    const [selectionFinancialCostCenter, setSelectionFinancialCostCenter] = useState(null);
    const [financialCostCenters, setFinancialCostCenters] = useState(null);
    const [selectionDefaultDescriptionCode, setSelectionDefaultDescriptionCode] = useState(null);
    const [defaultDescriptionCodes, setDefaultDescriptionCodes] = useState(null);

    const [accountigAccountsFilter, setAccountigAccountsFilter] = useState("");

    const [showUploadFinancialRecordsWindow, setShowUploadFinancialRecordsWindow] = useState(false);
    const [showFinancialPresetManager, setShowFinancialPresetManager] = useState(false);

    const [conciliationPresets, setConciliationPresets] = useState([]);

    const [splitting, setSplitting] = useState(false);

    const languageService = new LanguageService();
    const viewService = new ViewService("period-conciliation", {"periodId": conciliationPeriod.id});

    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    function getWindowDimensions() {
        const { innerWidth: width, innerHeight: height } = window;
        return {
          width,
          height
        };
      }
    
    useEffect(() => {
        // setHasAccess(authorizationService.hasPermission(MANAGE_PROFILES));

        // if(authorizationService.hasPermission(MANAGE_PROFILES)){
            async function fetchData() {
                const viewData = await viewService.load();
                setAccount(viewData.account);
                setCustomer(viewData.customer);
                setConciliationPeriod(viewData.period);
                setFinancialRecords(viewData.financialRecords);
                setConciliationRecords(viewData.conciliationRecords);
                setCustomerRecords(viewData.customerRecords);
                setCustomerCategories(viewData.customerCategories);
                setAccountigAccounts((viewData.accountigAccounts || []).map(i => ({label: i.name, value: i.id})));
                setAccountigCostCenters((viewData.accountigCostCenters || []).map(i => ({label: i.name, value: i.id})));
                setFinancialCategories((viewData.financialCategories || []).map(i => ({label: i.name, value: i.id})));
                setFinancialCostCenters((viewData.financialCostCenters || []).map(i => ({label: i.name, value: i.id})));
                setDefaultDescriptionCodes((viewData.defaultDescriptionCodes || []).map(i => ({label: i.name, value: i.id})));
                setConciliationPresets(viewData.conciliationPresets || []);

                setLoading(false);
                function handleResize() {
                    setWindowDimensions(getWindowDimensions());
                  }
              
                  window.addEventListener('resize', handleResize);
                  return () => window.removeEventListener('resize', handleResize);
            }        
            fetchData();
            
        //}
    }, []);

    const convertForSave = (list) => {
        return list.map(i => ({
            id: i.value,
            name: i.label,
            customer_id: customer.id
        }))
    }

    const save = async () => {
        try {
            setSaving(true);
            await viewService.save({ 
                financialRecords, 
                customerRecords, 
                conciliationRecords, 
                accountigAccounts: convertForSave(accountigAccounts), 
                accountigCostCenters: convertForSave(accountigCostCenters), 
                financialCategories: convertForSave(financialCategories), 
                financialCostCenters: convertForSave(financialCostCenters), 
                defaultDescriptionCodes : convertForSave(defaultDescriptionCodes)
            });
            setPendingUpdates(false);
            setSaving(false);
            toast.current.show({severity: 'success', summary: 'Successo', detail: 'Dados de conciliação salvos'});
        } catch (error) {
            console.log(error);
            toast.current.show({severity: 'error', summary: 'Ocorreu um erro', detail: error.toString()});
            setSaving(false);
        }
    }

    const toolbarTemplate = () => {
        return (
            <React.Fragment>
                { pendingUpdates && <Message severity="warn" text="Existem alterações não salvas" style={{marginRight: '10px'}}></Message>}
                { saving && <ProgressSpinner strokeWidth="10" style={{height: '25px'}}/> }
                <Button disabled={saving} label="Voltar" icon="pi pi-arrow-left" className="p-button-secondary p-mr-2" onClick={history.goBack} />
                <Button disabled={saving} label="Salvar" icon="pi pi-check" className="p-button-success p-mr-2" onClick={save} />
            </React.Fragment>
        )
    }

    const listHeader = (title) => (
        <div className="table-header">
            <h5 className="p-m-0">{title}</h5>
        </div>
    );

    const link = () => {

        const _conciliationRecords = [].concat(conciliationRecords);

        selectedConciliationRecords.forEach(financialRecord => {
            _conciliationRecords.find(cr => cr.financial_record_id === financialRecord.id).customer_record_id = selectedCompanyRecords[0].id;
        });

        setSelectedConciliationRecords([]);
        setSelectedCompanyRecords([]);
        setConciliationRecords(_conciliationRecords);
        setPendingUpdates(true);
    }

    const conciliationDetail = (conciliationRecord) => {
        //const conciliationRecord = conciliationRecords.find(cr => cr.financial_record_id === record.id);
        
        return <div>
            <b>Conta Contábil:</b>
            <br/>{(accountigAccounts.find(i => i.value === conciliationRecord.accounting_account_id) || {"label": "-"}).label}
            <br/><b>C.C. Contábil:</b>
            <br/>{(accountigCostCenters.find(i => i.value === conciliationRecord.accounting_cost_center_id) || {"label": "-"}).label}
            <br/><b>Cat. Financeira:</b>
            <br/>{(financialCategories.find(i => i.value === conciliationRecord.financial_category_id) || {"label": "-"}).label}
            <br/><b>C.C. Financeiro:</b>
            <br/>{(financialCostCenters.find(i => i.value === conciliationRecord.financial_cost_center_id) || {"label": "-"}).label}
            <br/><b>Hist. Padrão:</b>
            <br/>{(defaultDescriptionCodes.find(i => i.value === conciliationRecord.default_description_code_id) || {"label": "-"}).label}
        </div>
    }

    const concilitationStatus = (conciliationRecord) => {
        //const {accounting_account_id, accounting_cost_center_id, financial_category_id, financial_cost_center_id, default_description_code_id } = conciliationRecords.find(cr => cr.financial_record_id === record.id);
        const {accounting_account_id, accounting_cost_center_id, financial_category_id, financial_cost_center_id, default_description_code_id } = conciliationRecord;
        const sum = ((accounting_account_id || "") === "" ? 0 : 1) +
                    ((accounting_cost_center_id || "") === "" ? 0 : 1) + 
                    ((financial_category_id || "") === "" ? 0 : 1) +
                    ((financial_cost_center_id || "") === "" ? 0 : 1) +
                    ((default_description_code_id || "") === "" ? 0 : 1);
        
        return sum === 5 ? "DONE" : sum === 0 ? "EMPTY" : "INCOMPLETE";
    }

    const openClassification = () => {

        setSelectionAccountingAccount(null);
        setSelectionAccountingCostCenter(null);
        setSelectionFinancialCategory(null);
        setSelectionFinancialCostCenter(null);
        setSelectionDefaultDescriptionCode(null);
        
        //const selectedConciliationRecords = selectedConciliationRecords.map(fr => conciliationRecords.find(cr => cr.financial_record_id === fr.id));
        
        const groupedAccountingAccounts = Object.keys(_.groupBy(selectedConciliationRecords, 'accounting_account_id'));
        setSelectionAccountingAccount(groupedAccountingAccounts.length === 1 && groupedAccountingAccounts[0] !== "null" && groupedAccountingAccounts[0] !== "undefined" ? groupedAccountingAccounts[0] : null);

        const groupedAccountingCostCenters = Object.keys(_.groupBy(selectedConciliationRecords, 'accounting_cost_center_id'));
        setSelectionAccountingCostCenter(groupedAccountingCostCenters.length === 1 && groupedAccountingCostCenters[0] !== "null" && groupedAccountingCostCenters[0] !== "undefined" ? groupedAccountingCostCenters[0] : null);

        const groupedFinancialCategories = Object.keys(_.groupBy(selectedConciliationRecords, 'financial_category_id'));
        setSelectionFinancialCategory(groupedFinancialCategories.length === 1 && groupedFinancialCategories[0] !== "null" && groupedFinancialCategories[0] !== "undefined" ? groupedFinancialCategories[0] : null);

        const groupedFinanncialCostCenters = Object.keys(_.groupBy(selectedConciliationRecords, 'financial_cost_center_id'));
        setSelectionFinancialCostCenter(groupedFinanncialCostCenters.length === 1 && groupedFinanncialCostCenters[0] !== "null" && groupedFinanncialCostCenters[0] !== "undefined" ? groupedFinanncialCostCenters[0] : null);

        const groupedDefaultDescriptionCodes = Object.keys(_.groupBy(selectedConciliationRecords, 'default_deescription_code_id'));
        setSelectionDefaultDescriptionCode(groupedDefaultDescriptionCodes.length === 1 && groupedDefaultDescriptionCodes[0] !== "null" && groupedDefaultDescriptionCodes[0] !== "undefined" ? groupedDefaultDescriptionCodes[0] : null);

        setClassifying(true);
    }

    const applyAutomaticConciliationPresets = (rules) => {
        const _financialRecords = [].concat(financialRecords);
        const _conciliationRecords = [].concat(conciliationRecords);
        _financialRecords.forEach(record => {
            rules.sort((a,b) => a.priority > b.priority ? 1 : -1).forEach(preset => {
                if(evaluateAutomaticRule(record, preset)){
                    _conciliationRecords.find(cr => cr.financial_record_id === record.id).accounting_account_id = preset.accounting_account_id;
                    _conciliationRecords.find(cr => cr.financial_record_id === record.id).accounting_cost_center_id = preset.accounting_cost_center_id;
                    _conciliationRecords.find(cr => cr.financial_record_id === record.id).financial_category_id = preset.financial_category_id;
                    _conciliationRecords.find(cr => cr.financial_record_id === record.id).financial_cost_center_id = preset.financial_cost_center_id;
                    _conciliationRecords.find(cr => cr.financial_record_id === record.id).default_description_code_id = preset.default_description_code_id;
                }    
            });
        });
        setConciliationRecords(_conciliationRecords);
        setPendingUpdates(true);
        toast.current.show({severity: 'success', summary: 'Successo', detail: 'Regras aplicadas com successo'});
    }

    const evaluateAutomaticRule = (record, rule) => {
        if((rule.comparison_operator || "") === "" || (rule.comparison_value || "") === ""){
            return false;
        }

        if(rule.comparison_operator === "EQUAL" && rule.comparison_value.toUpperCase() === (record.description || "").toUpperCase()){
            return true;
        }

        if(rule.comparison_operator === "CONTAINS" && (record.description || "").toUpperCase().indexOf(rule.comparison_value.toUpperCase()) >= 0){
            return true;
        }

        return false;
    }

    const applyConciliationPreset = (preset) => {
        const _conciliationRecords = [].concat(conciliationRecords);
        selectedConciliationRecords.forEach(record => {
            _conciliationRecords.find(cr => cr.id === record.id).accounting_account_id = preset.accounting_account_id;
            _conciliationRecords.find(cr => cr.id === record.id).accounting_cost_center_id = preset.accounting_cost_center_id;
            _conciliationRecords.find(cr => cr.id === record.id).financial_category_id = preset.financial_category_id;
            _conciliationRecords.find(cr => cr.id === record.id).financial_cost_center_id = preset.financial_cost_center_id;
            _conciliationRecords.find(cr => cr.id === record.id).default_description_code_id = preset.default_description_code_id;
        });
        setConciliationRecords(_conciliationRecords);
        setPendingUpdates(true);
    }

    const clearConciliation = (preset) => {
        const _conciliationRecords = [].concat(conciliationRecords);
        // selectedConciliationRecords.forEach(record => {
        //     _conciliationRecords.find(cr => cr.financial_record_id === record.id).accounting_account_id = null;
        //     _conciliationRecords.find(cr => cr.financial_record_id === record.id).accounting_cost_center_id = null;
        //     _conciliationRecords.find(cr => cr.financial_record_id === record.id).financial_category_id = null;
        //     _conciliationRecords.find(cr => cr.financial_record_id === record.id).financial_cost_center_id = null;
        //     _conciliationRecords.find(cr => cr.financial_record_id === record.id).default_description_code_id = null;
        // });
        selectedConciliationRecords.forEach(record => {
            _conciliationRecords.find(cr => cr.id === record.id).accounting_account_id = null;
            _conciliationRecords.find(cr => cr.id === record.id).accounting_cost_center_id = null;
            _conciliationRecords.find(cr => cr.id === record.id).financial_category_id = null;
            _conciliationRecords.find(cr => cr.id === record.id).financial_cost_center_id = null;
            _conciliationRecords.find(cr => cr.id === record.id).default_description_code_id = null;
        });
        setConciliationRecords(_conciliationRecords);
        setPendingUpdates(true);
    }

    const checkForNewItem = (id, list, listSetter) => {
        const existingItem = list.find(i => i.value === id || i.label === id)
        if(existingItem){
            return existingItem.value;
        }
        else {
            const newId = uuidv4();
            listSetter(list.concat({ value: newId, label: id }));
            setPendingUpdates(true);
            return newId;
        }
    }

    const applyClassification = () => {
        const _conciliationRecords = [].concat(conciliationRecords);
        
        selectedConciliationRecords.forEach(record => {
            if(selectionAccountingAccount)
                _conciliationRecords.find(cr => cr.id === record.id).accounting_account_id = checkForNewItem(selectionAccountingAccount, accountigAccounts, setAccountigAccounts);
            
            if(selectionAccountingCostCenter)
                _conciliationRecords.find(cr => cr.id === record.id).accounting_cost_center_id = checkForNewItem(selectionAccountingCostCenter, accountigCostCenters, setAccountigCostCenters);
            
            if(selectionFinancialCategory)
                _conciliationRecords.find(cr => cr.id === record.id).financial_category_id = checkForNewItem(selectionFinancialCategory, financialCategories, setFinancialCategories);
            
            if(selectionFinancialCostCenter)
                _conciliationRecords.find(cr => cr.id === record.id).financial_cost_center_id = checkForNewItem(selectionFinancialCostCenter, financialCostCenters, setFinancialCostCenters);

            if((selectionDefaultDescriptionCode || "") !== "")
                _conciliationRecords.find(cr => cr.id === record.id).default_description_code_id = checkForNewItem(selectionDefaultDescriptionCode, defaultDescriptionCodes, setDefaultDescriptionCodes);
        });

        setSelectionAccountingAccount(null);
        setSelectionAccountingCostCenter(null);
        setSelectionFinancialCategory(null);
        setSelectionFinancialCostCenter(null);
        setSelectionDefaultDescriptionCode(null);
        setConciliationRecords(_conciliationRecords);
        setClassifying(false);
        setPendingUpdates(true);
    }

    const updateFinancialRecords = (updatedFinancialRecords) => {
        const _conciliationRecords = [].concat(conciliationRecords);
        updatedFinancialRecords.forEach(record => {
            if(!_conciliationRecords.find(cr => cr.financial_record_id === record.id)){
                const newConciliationRecord = {
                    id: uuidv4(),
                    account_id: account.id,
                    financial_record_id: record.id,
                    value: record.value,
                    period_id: conciliationPeriod.id
                }
                
                conciliationPresets.sort((a,b) => a.priority > b.priority ? 1 : -1).forEach(preset => {
                    if(evaluateAutomaticRule(record, preset)){
                        newConciliationRecord.accounting_account_id = preset.accounting_account_id;
                        newConciliationRecord.accounting_cost_center_id = preset.accounting_cost_center_id;
                        newConciliationRecord.financial_category_id = preset.financial_category_id;
                        newConciliationRecord.financial_cost_center_id = preset.financial_cost_center_id;
                        newConciliationRecord.default_description_code_id = preset.default_description_code_id;
                    }    
                });

                _conciliationRecords.push(newConciliationRecord);
            }
        });
        setFinancialRecords(updatedFinancialRecords);
        setConciliationRecords(_conciliationRecords);
        setPendingUpdates(true);
    }

    const formatCurrency = (value) => {
		return parseFloat(value).toLocaleString('pt-BR',{minimumFractionDigits: 2, style: 'currency', currency: 'BRL'});
    };

    const exportConciliationFile = () => {

        let content = "";

        conciliationRecords.forEach(conciliationRecord => {

            const financialRecord = financialRecords.find(fr => fr.id === conciliationRecord.financial_record_id);

            // EM BRANCO Posição 1 (00001) Descrição: Código do Lançamento Automático 
            const pos1 = "";

            // Posição 2 (35 ) Descrição:   Código Conta Débito (Código de Chamada)
            const pos2 = financialRecord.value >= 0 ? account.number : conciliationRecord.accounting_account_id || "";

            // Posição 3 (49 ) Descrição:    Código Conta Crédito(Código de Chamada)
            const pos3 = financialRecord.value >= 0 ? conciliationRecord.accounting_account_id || "" : account.number;

            // Posição 4 ( 01/01/2015 ) Descrição:    Data do Lançamento (DD/MM/AAAA)
            const pos4 = `${financialRecord.date.substring(8,10)}/${financialRecord.date.substring(5,7)}/${financialRecord.date.substring(0,4)}`;

            // Posição 5 ( 1000.00 ) Descrição:    Valor do Lançamento (Sem virgula apenas o ponto)
            const pos5 = financialRecord.value;

            // PRECISAMOS PREVER ESSE CAMPO NA CONCILIAÇÃO TAMBÉM Posição 6 ( 00001 ) Descrição:    Código do Histórico Padrão
            const pos6 = conciliationRecord.default_description_code_id || "";

            // Posição 7 ( Sem código histórico ) Descrição:     Descrição do Histórico
            const pos7 = financialRecord.description || "";

            // Posição 8 ( 00001 ) Descrição:    Número de Documento
            const pos8 = "";

            content += `"${pos1}","${pos2}","${pos3}","${pos4}","${pos5}","${pos6}","${pos7}","${pos8}"\n`;
        });

        


        const element = document.createElement("a");
        const file = new Blob([content], {type: 'text/plain'});
        element.href = URL.createObjectURL(file);
        element.download = `conciliacao_${customer.name}_${conciliationPeriod.start_date.substring(0, 10)}_${conciliationPeriod.end_date.substring(0, 10)}_${account.bank_id}_${account.number}.csv`;
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();
    }

    const getConciliationRecordsSorter = () => {
        return (a, b) => financialRecords.find(fr => fr.id === a.financial_record_id)[conciliationRecordsSort.sortField] >= financialRecords.find(fr => fr.id === b.financial_record_id)[conciliationRecordsSort.sortField] ? conciliationRecordsSort.sortOrder : -1*conciliationRecordsSort.sortOrder;
    }

    const hasSiblings = (record) => {
        return conciliationRecords.filter(r => r.id !== record.id && r.financial_record_id === record.financial_record_id).length > 0;
    }

    const contextMenu = conciliationPresets.map(p => ({ label: p.name, icon: 'pi pi-angle-right', command: () => applyConciliationPreset(p)}));
    contextMenu.push({ separator:true });
    contextMenu.push({ label: "Limpar", icon: 'pi pi-times', command: () => clearConciliation() });

    return (
        <>
        <div className="datatable-crud-demo" style={{height: '90vh'}}>
            <Toast ref={toast} />
            <div className="card" style={{height: '100%'}}>
                { loading && <ProgressBar mode="indeterminate"/> }
                { !loading && 
                
                    <>
                    <div style={{height: '100%', display: 'flex', flexDirection: 'column', alignContent: 'stretch'}}>
                        <div style={{height: '70px'}}>
                            <Toolbar className="p-mb-4" left={<h5 className="p-m-0">Conciliação</h5>} right={toolbarTemplate}></Toolbar>
                        </div>
                        <div style={{height: '60px'}}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-6 p-lg-6"><b>Empresa:</b> {customer.name}</div>
                                <div className="p-col-12 p-md-6 p-lg-6"><b>Conta:</b> {account.name}</div>
                                <div className="p-col-12 p-md-6 p-lg-6"><b>Período:</b> {conciliationPeriod.name}</div>
                                <div className="p-col-12 p-md-6 p-lg-6"><b>Status:</b> {conciliationPeriod.status}</div>        
                            </div>
                        </div>
                        <div style={{height: '70px'}}>
                            <div className="p-grid">
                                <div className="p-col">
                                    <Toolbar
                                        left={
                                            <>
                                                <Button disabled={saving} icon="pi pi-upload" className="p-button-success p-mr-2" tooltip="Subir OFX" tooltipOptions={{position: 'bottom'}} onClick={() => setShowUploadFinancialRecordsWindow(true)} />
                                                <Button disabled={saving} icon="pi pi-cog" className="p-button-success p-mr-2" tooltip="Pré-Configurações" tooltipOptions={{position: 'bottom'}} onClick={() => setShowFinancialPresetManager(true)} />
                                                <Button disabled={saving} icon="pi pi-download" className="p-button-success p-mr-2" tooltip="Baixar Arquivo Alterdata" tooltipOptions={{position: 'bottom'}} onClick={() => exportConciliationFile()} />
                                            </>
                                        }
                                        right={
                                            <>
                                                <Button disabled={saving || selectedConciliationRecords.length === 0} icon="pi pi-tag" className="p-button-success p-mr-2" tooltip="Classificar" tooltipOptions={{position: 'bottom'}} onClick={() => openClassification()}/>
                                                <Button disabled={saving || selectedConciliationRecords.length !== 1} icon="pi pi-clone" className="p-button-success p-mr-2" tooltip="Dividir" tooltipOptions={{position: 'bottom'}} onClick={() => setSplitting(true)}/>
                                            </>
                                        }
                                    />
                                </div>
                                <div className="p-col">
                                    <Toolbar
                                        left={<Button disabled={saving} icon="pi pi-upload" className="p-button-success p-mr-2" tooltip="Subir Arquivo" tooltipOptions={{position: 'bottom'}} />}
                                    />
                                </div>
                            </div>
                        </div>
                        <div style={{flex: 1, overflow: 'hidden'}}>
                            <div style={{display: 'flex', height: '100%'}}>
                                <ContextMenu model={contextMenu} ref={frcm}></ContextMenu>
                                
                                <div onContextMenu={(e) => { if(selectedConciliationRecords.length > 0){frcm.current.show(e)}else{e.preventDefault()}}} style={{flex: 1, height: '100%', overflow: 'hidden'}}>
                                    <div>
                                    <DataTable value={(conciliationRecords || []).filter(i => !i.deleted).sort(getConciliationRecordsSorter())}
                                    dataKey="id"
                                    header={listHeader({"pt-BR": "Lançamentos Financeiros", "en-US": "Financial Records"}[languageService.language])}
                                    style={{width: '100%'}}
                                    scrollable scrollHeight={`${windowDimensions.height - 415}px`}
                                    selectionMode="multiple" 
                                    selection={selectedConciliationRecords} 
                                    onSelectionChange={e => setSelectedConciliationRecords(e.value)}
                                    sortField={conciliationRecordsSort.sortField}
                                    sortOrder={conciliationRecordsSort.sortOrder}
                                    onSort={(e) => setConciliationRecordsSort(e)}
                                    >
                                        <Column field="date" header="Data" sortable style={{textAlign: 'center', width: '100px'}} body={(data) => moment(financialRecords.find(fr => fr.id === data.financial_record_id).date).utc().format("DD/MM/YYYY")}></Column>
                                        <Column field="description" header="Descrição" sortable body={(data) => financialRecords.find(fr => fr.id === data.financial_record_id).description}></Column>
                                        <Column field="value" header="Valor" sortable style={{textAlign: 'right', width: '120px'}}  body={(data) => formatCurrency(data.value)}></Column>
                                        <Column header="Status" style={{textAlign: 'center', width: '100px'}} body={(data) => 
                                            <>
                                            <Tooltip target={`.financialRecordsTooltip_${data.id}`} position="bottom" style={{width: '400px'}}>{ conciliationDetail(data)}</Tooltip>
                                            <i 
                                                className={`pi ${concilitationStatus(data) === "DONE" ? 'pi-check-circle' : concilitationStatus(data) === "INCOMPLETE" ? 'pi-info-circle' : 'pi-minus-circle'} financialRecordsTooltip_${data.id}`} 
                                                style={{color: concilitationStatus(data) === "DONE" ? 'green' : concilitationStatus(data) === "INCOMPLETE" ? 'orange' : 'gray', fontWeight: 'bold'}}   
                                            />
                                            </>
                                        }></Column>
                                        <Column field="id" header="" style={{textAlign: 'left', width: '35px'}} body={(data) => hasSiblings(data) ? <i className="pi pi-clone"></i> : ""}></Column>
                                        
                                </DataTable>
                                    <br/>
                                    { selectedConciliationRecords.length > 0 && <div>Soma: {(selectedConciliationRecords || []).reduce((sum, r) => sum + parseFloat(r.value), 0)}</div>}
                                    { classifying &&
                                        <Dialog visible={true} style={{width: '40vw'}} header="Classificar"  onHide={() => setClassifying(false)}
                                            footer={
                                                <>
                                                    <Button label="Salvar" icon="pi pi-check" className="p-button-success" onClick={() => applyClassification()} />
                                                    <Button label="Fechar" icon="pi pi-times" className="p-button-secondary p-mr-2" onClick={() => setClassifying(false)} />                                                
                                                </>
                                            }
                                            >
                                            <div className="p-grid">
                                                <div className="p-col-12"><b>Conta Contábil:</b></div>
                                                <div className="p-col-12">
                                                    <Dropdown value={selectionAccountingAccount} options={accountigAccounts} onChange={(e) => setSelectionAccountingAccount(e.value)} placeholder="Selecione" style={{width: '100%'}} editable/>
                                                </div>
                                                <div className="p-col-12"><b>Centro de Custo Contábil:</b></div>
                                                <div className="p-col-12">
                                                    <Dropdown value={selectionAccountingCostCenter} options={accountigCostCenters} onChange={(e) => setSelectionAccountingCostCenter(e.value)} placeholder="Selecione" style={{width: '100%'}} editable/>
                                                </div>
                                                <div className="p-col-12"><b>Categoria Financeira:</b></div>
                                                <div className="p-col-12">
                                                    <Dropdown value={selectionFinancialCategory} options={financialCategories} onChange={(e) => setSelectionFinancialCategory(e.value)} placeholder="Selecione" style={{width: '100%'}} editable/>
                                                </div>
                                                <div className="p-col-12"><b>Centro de Custo Financeiro:</b></div>
                                                <div className="p-col-12">
                                                    <Dropdown value={selectionFinancialCostCenter} options={financialCostCenters} onChange={(e) => setSelectionFinancialCostCenter(e.value)} placeholder="Selecione" style={{width: '100%'}} editable/>
                                                </div>
                                                <div className="p-col-12"><b>Histórico Padrão:</b></div>
                                                <div className="p-col-12">
                                                    <Dropdown value={selectionDefaultDescriptionCode} options={defaultDescriptionCodes} onChange={(e) => setSelectionDefaultDescriptionCode(e.value)} placeholder="Selecione" style={{width: '100%'}} editable/>
                                                </div>
                                            </div>
                                        </Dialog>
                                    }
                                    </div>
                                </div>
                                <div style={{width: '18px', height: '100%', overflow: 'scroll'}}>
                                </div>
                                <div style={{flex: 1, height: '100%', overflow: 'scroll'}}>
                                    <div>
                                    <DataTable value={customerRecords || []}
                                        dataKey="id"
                                        header={listHeader({"pt-BR": "Lançamentos Empresa", "en-US": "Company Records"}[languageService.language])}
                                        autoLayout={(props.hasOwnProperty("autoLayout") ? props.autoLayout : true)}
                                        style={{width: '100%'}}
                                        scrollable scrollHeight={`${windowDimensions.height - 415}px`}
                                        selectionMode="multiple" 
                                        selection={selectedCompanyRecords} 
                                        onSelectionChange={e => setSelectedCompanyRecords(e.value)}
                                        >
                                            <Column header="Data" body={(data) => moment(data.date).utc().format("DD/MM/YYYY")}></Column>
                                            <Column header="Descrição" body={(data) => data.description}></Column>
                                            <Column header="Valor" body={(data) => data.value}></Column>
                                            <Column header="Categoria" body={(data) => (customerCategories.find(c => c.id === data.customer_category_id) || {}).name}></Column>
                                    </DataTable>
                                    </div>
                                    <div className="p-col-12">
                                        { selectedCompanyRecords.length > 0 && <div>Soma: {(selectedCompanyRecords || []).reduce((sum, r) => sum + parseFloat(r.value), 0)}</div>}
                                    </div>
                                    </div>
                            </div>     
                                                 
                        </div>
                        { selectedConciliationRecords.length > 0 && selectedCompanyRecords.length === 1 && <Button label={"Linkar"} onClick={() => link()}/>}
                    </div>
                    </>
                }

                { showUploadFinancialRecordsWindow && <>
                    <FinancialRecordsUploader
                        account={account}
                        period={conciliationPeriod}
                        records={financialRecords} 
                        onUpdate={updateFinancialRecords}
                        onClose={() => setShowUploadFinancialRecordsWindow(false)}
                    />
                </>}

                { showFinancialPresetManager && <>
                    <FinancialPresetManager
                        customer={customer}
                        onUpdate={(data) => {
                            setConciliationPresets(data);
                            toast.current.show({severity: 'success', summary: 'Successo', detail: 'Pré-configurações salvas'});
                        }}
                        onClose={() => setShowFinancialPresetManager(false)}
                        onRulesApply={(rules) => applyAutomaticConciliationPresets(rules)}
                    />
                </>}

                { splitting && <>
                    <RecordSplitter
                        records={conciliationRecords.filter(r => r.financial_record_id === selectedConciliationRecords[0].financial_record_id)}
                        financialRecords={financialRecords}
                        onUpdate={(updatesRecords) => {
                            const _conciliationRecords = [].concat(conciliationRecords);

                            updatesRecords.forEach(updatedRecord => {
                                let existingRecord = _conciliationRecords.find(r => r.id === updatedRecord.id);
                                if(existingRecord){
                                    existingRecord = Object.assign({}, updatedRecord);
                                }
                                else {
                                    _conciliationRecords.push(Object.assign({}, updatedRecord));
                                }
                            });
                            setConciliationRecords(_conciliationRecords);
                            setPendingUpdates(true);
                            setSplitting(false);
                            toast.current.show({severity: 'success', summary: 'Successo', detail: 'Registro dividido'});
                        }}
                        onClose={() => setSplitting(false)}
                    />
                </>}

            </div>
        </div>
        
        </>
    );
}

export default ConciliatePeriod;